import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

import "../assets/css/bootstrap.min.css";
import "../assets/css/icons.min.css";
import "../assets/libs/simplebar/simplebar.min.css";
import "../assets/css/app.min.css";
import "../assets/custom.css";

const sidebarConfig = [
  {
    key: "operations",
    title: "Operations",
    icon: "fas fa-cogs",
    items: [
      { path: "/MonthlyInvoice", label: "Monthly Invoice", icon: "fas fa-file-invoice-dollar" },
      { path: "/OtherInvoice", label: "Other Invoice", icon: "fas fa-file-invoice-dollar" },
      { path: "/OnboardProcess", label: "Onboarding Verification", icon: "fas fa-user-plus" },
      { path: "/CustomerList", label: "Customers / Tenants", icon: "fas fa-user" },
    ],
  },
  {
    key: "settings",
    title: "Accounts",
    icon: "fas fa-layer-group",
    items: [
      { path: "/transaction", label: "Journal Entry", icon: "fas fa-exchange-alt" },
      { path: "/grouping", label: "Account Heads", icon: "fas fa-layer-group" },
      { path: "/ledger", label: "Chart of Accounts", icon: "fas fa-book" },
      { path: "/monthly-journal", label: "Monthly Journal", icon: "fas fa-calendar-check" },
      { path: "/voucher-allocation", label: "Voucher Allocation", icon: "fas fa-exchange-alt" },
      { path: "/open-balance-list", label: "Opening Balance", icon: "fas fa-balance-scale" },
      { path: "/report-group-settings", label: "Report Settings", icon: "fas fa-cogs" },
    ],
  },
  {
    key: "reports",
    title: "Reports",
    icon: "fas fa-chart-line",
    items: [
      { path: "/statement-ledger", label: "Ledger Statement", icon: "fas fa-balance-scale" },
      { path: "/profit-loss", label: "Profit & Loss", icon: "fas fa-chart-line" },
      { path: "/balance-sheet", label: "Balance Sheet", icon: "fas fa-chart-pie" },
      { path: "/trial-balance", label: "Trial Balance", icon: "fas fa-file-alt" },
      { path: "/history-log", label: "Journal History Log", icon: "fas fa-history" },
    ],
  },
];

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isContextSet, setIsContextSet] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  useEffect(() => {
    const context = sessionStorage.getItem("selectedContext");
    setIsContextSet(!!context);
  }, [location]);

  // 🔥 AUTO OPEN SECTION BASED ON ROUTE
  useEffect(() => {
    const currentPath = location.pathname;

    const activeSection = sidebarConfig.find(section =>
      section.items.some(item =>
        currentPath.startsWith(item.path)
      )
    );

    if (activeSection) {
      setOpenSection(activeSection.key);
    }
  }, [location.pathname]);

  const handleRestrictedClick = (e) => {
    if (!isContextSet) {
      e.preventDefault();
      alert("Please select Company, Branch & FY first.");
      navigate("/select-context");
    }
  };

  const toggleSection = (key) => {
    setOpenSection(prev => (prev === key ? null : key));
  };


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === "j") {
        e.preventDefault();
        if (!isContextSet) {
          alert("Please select Company, Branch & FY first.");
          navigate("/select-context");
        } else {
          navigate("/transaction");
        }
      }

      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === "l") {
        e.preventDefault();
        if (!isContextSet) {
          alert("Please select Company, Branch & FY first.");
          navigate("/select-context");
        } else {
          navigate("/ledger");
        }
      }

      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === "k") {
        e.preventDefault();
        if (!isContextSet) {
          alert("Please select Company, Branch & FY first.");
          navigate("/select-context");
        } else {
          navigate("/statement-ledger");
        }
      }

      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === "r") {
        e.preventDefault();
        if (!isContextSet) {
          alert("Please select Company, Branch & FY first.");
          navigate("/select-context");
        } else {
          navigate("/trial-balance");
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isContextSet, navigate]);


  return (
    <div
      className={`sidebar-left ${!isContextSet ? "sidebar-disabled" : ""}`}
      id="sidebar-left"
    >
      <div data-simplebar className="h-100">
        <div id="sidebar-menu">
          <ul className="left-menu list-unstyled" id="side-menu">

            {/* DASHBOARD */}
            <li>
              <NavLink
                to="/dashboard"
                onClick={handleRestrictedClick}
                className={({ isActive }) =>
                  isActive ? "active mm-active" : ""
                }
              >
                <i className="fas fa-tachometer-alt me-2"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>

            {/* DYNAMIC SECTIONS */}
            {sidebarConfig.map(section => (
              <li
                key={section.key}
                className={openSection === section.key ? "mm-active" : ""}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSection(section.key);
                  }}
                  className="has-arrow"
                >
                  <i className={`${section.icon} me-2`}></i>
                  <span>{section.title}</span>
                </a>

                <ul
                  className={`submenu list-unstyled ${openSection === section.key ? "show" : ""
                    }`}
                >
                  {section.items.map(item => (
                    <li key={item.path}>
                      <NavLink
                        to={item.path}
                        onClick={handleRestrictedClick}
                        className={({ isActive }) =>
                          isActive ? "active-link" : ""
                        }
                      >
                        <i className={`${item.icon} me-2`}></i>
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
            ))}

            {/* Short cut keys */}
            <li>
              <NavLink
                to="#"
              >
                <i className="fas fa-key me-2"></i>
                <span>Shortcuts</span>
              </NavLink>
            </li>

            <li className="ps-3">
              <NavLink
                to="#"
              >
                <span className="badge bg-primary">Ctrl+Alt+J</span>
                <span className="fs-12"> Journal Entry</span>
              </NavLink>
            </li>

            <li className="ps-3">
              <NavLink
                to="#"
              >
                <span className="badge bg-primary">Ctrl+Alt+L</span>
                <span className="fs-12"> Account Heads </span>
              </NavLink>
            </li>

            <li className="ps-3">
              <NavLink
                to="#"
              >
                <span className="badge bg-primary">Ctrl+Alt+K</span>
                <span className="fs-12"> Ledger Statement </span>
              </NavLink>
            </li>

            <li className="ps-3">
              <NavLink
                to="#"
              >
                <span className="badge bg-primary">Ctrl+Alt+R</span>
                <span className="fs-12"> Trial Balance </span>
              </NavLink>
            </li>


          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;